export const TOAST_EVENT = 'mauj:toast'

/** Shows a short message at the bottom of the screen. */
export function toast(message: string) {
  window.dispatchEvent(new CustomEvent<string>(TOAST_EVENT, { detail: message }))
}
